import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import Helmet from "react-helmet";
import styled from "styled-components";

import Publishing from "./Publishing";
import ReadCategory from "./ReadCategory.graphql";

const StyledCategoryTitleHeader = styled.div`
    align-items: center;
    border-bottom: 1px solid #ebecf0;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-bottom: 16px;

    .title-left {
        align-items: center;
        display: flex;
        gap: 12px;
    }

    h1 {
        color: #172b4d;
        font-size: 1.35rem;
        font-weight: 700;
        letter-spacing: -0.01em;
        margin: 0;
    }

    .badge {
        border-radius: 4px;
        font-size: 0.7rem;
        font-weight: 700;
        letter-spacing: 0.02em;
        padding: 2px 6px;
        text-transform: uppercase;

        &.public {
            background: #e3fcef;
            color: #006644;
        }

        &.draft {
            background: #deebff;
            color: #0747a6;
        }
    }
`;

export default function CategoryTitle(props) {
    const { id } = props;

    const readCategory = useQuery(
        gql(ReadCategory),
        {
            variables: {
                id,
            },
        },
    );

    if (readCategory.loading || readCategory.error || !readCategory.data?.category) return null;

    const isPublic = readCategory.data.additionalCategoryData?.public;
    const categoryName = readCategory.data.category.name[0]?.text ?? "Untitled Category";

    return (
        <StyledCategoryTitleHeader>
            <Helmet>
                <title>C - { categoryName } - taxonomy</title>
            </Helmet>
            <div className="title-left">
                <h1>{ categoryName }</h1>
                <span className={ `badge ${ isPublic ? "public" : "draft" }` }>
                    { isPublic ? "Public" : "Draft" }
                </span>
                <Publishing
                    id={ id }
                    public={ isPublic }
                />
            </div>
        </StyledCategoryTitleHeader>
    );
}
